
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import { Search } from 'lucide-react';
import classes from "./ComplianceReport.module.css";
import plus from "../../../Assets/plus.svg"
import ReportBackground from "../../../Assets/report.svg"
import run from "../../../Assets/run.svg"
import MailLogo from "../../../Assets/mail.svg"
import PrintLogo from "../../../Assets/print.svg"
import ExcelLogo from "../../../Assets/excel.png"
import PdfLogo from "../../../Assets/pdf.png"
import DownloadLogo from "../../../Assets/down.svg"
import BackLogo from "../../../Assets/back.svg"
import RotatingLogo from '../../../Assets/rotating-logo.png'
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"

import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';

// import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import HeaderNav from "../../Accoungting/HeaderNav/FixedAssetNav";
import axios from "axios";
import { BASE_URL, TOKEN, BASE_URL1 } from "../../../Components/Styles/API/API";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import download from "../../../Assets/download1.svg"
import upload from "../../../Assets/upload.svg"
import logo from "../../../Assets/rotating-logo.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import * as XLSX from 'xlsx'; // Import xlsx library
import { saveAs } from 'file-saver';
import jsPDF from "jspdf";
import "jspdf-autotable";







const ComplianceReport = () => {
  const location = useLocation();
  const [noData, setNoData] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [load, setLoad] = useState(false);
  const [tableData3, setTableData3] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [selectedContinent, setSelectedContinent] = useState('');
  const [tableData45, setTableData45] = useState([]);
  const [totalDebit, setTotalDebit] = useState('');
  const [totalCredit, setTotalCredit] = useState('');
  const [allAccounts, setAllAccounts] = useState([]);
  const [fetchingLoading, setFetchingLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBank, setSelectedBank] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [searchedResult, setSearchedResult] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState("");
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [savingsLoading, setSavingsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [cashbook, setCashbook] = useState([]);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [currentMonth, setCurrentMonth] = useState("");
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedEndDate, setSelectedEndDate] = useState('');
  const [inputss, setInputss] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [province1, setProvince1] = useState('');
  const [usert, setUsert] = useState("");
  const [admin, setAdmin] = useState('');
  const [totalClosing, setTotalClosing] = useState('');
  const [totalOpening, setTotalOpening] = useState('');

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const current = await localStorage.getItem('currentMonth');
      const admins = await localStorage.getItem('admin');
      // const saved = localStorage.getItem("cashbook_preview");
      const continentName = await localStorage.getItem('continent');
      const regionName = await localStorage.getItem('region');
      const provinceName = await localStorage.getItem('province');
      const provinceid = await localStorage.getItem('provinceID');
      const continentid = await localStorage.getItem('continentID');
      const regionid = await localStorage.getItem('regionID');
      const usertype = await localStorage.getItem('userType');
  
      if (value !== null) {
        setBearer(value);
      }

      if (provinceid !== null) {
        setSelectedProvince(provinceid);
      }
      if (continentid !== null) {
        setSelectedContinent(continentid);
      }
      if (regionid !== null) {
        setSelectedRegion(regionid);
      }
      if (usertype !== null) {
        setUsert(usertype);
      }
      // if (saved) {
      //   setCashbook(JSON.parse(saved));
      // }

      if (value1 !== null) {
        setUser(value1);
      }
      if (current !== null) {
        console.log(current);
        const date = new Date(current);

        setCurrentMonth(date);

        const startOfDateRange = new Date(1900, 0, 1);

        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));

        console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
      }
      if (admins !== null) {
        setAdmin(admins);
      }
      if (continentName !== null) {
        setContinent(continentName);
      }
      if (regionName !== null) {
        setRegion(regionName);
      }
      if (provinceName !== null) {
        setProvince(provinceName);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };







  const handleShow1 = (loan) => {
    setLoanCode(loan.code);
    setLoanDescription(loan.description);
    setSelectedReportTo(loan.reportTo);
    setShow1(true);
  };

  const handleClose1 = () => setShow1(false);


  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);




  // const fetchAccounts = async () => {
  //   setSavingsLoading(true);
  //   try {
  //     const response = await axios.get(`${BASE_URL}/reports/get-trial-balance`, {
  //       params: {
  //         // gl_code: selectedBank?.value || "",
  //         start_date: selectedDate,
  //         end_date: selectedEndDate,
  //         continent_id: selectedContinent || "",
  //         region_id: selectedRegion || "",
  //         province_id: selectedProvince || ""
  //       },
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${bearer}`
  //       }
  //     });

  //     if (!response.data?.data?.journal || response.data?.data?.journal.length === 0) {
  //       setAccounts([]);   // ✅ clear previous data
  //       setNoData(true);
  //       return;
  //     }

  //     const resultsss = response.data?.data?.journal;
  //     const resultssx = response.data?.data?.input;

  //     setAccounts(resultsss);
  //     setInputss(resultssx);
  //     setNoData(false);

  //     console.log(resultsss);

  //   } catch (error) {
  //     if (error.response && error.response.status === 401) {
  //       navigate('/login');
  //     } else {
  //       console.log(error);
  //       setAccounts([]);   // ✅ also clear here on error
  //       setNoData(true);
  //     }
  //   } finally {
  //     setSavingsLoading(false);
  //   }
  // };

const fetchAccounts = async () => {
  setSavingsLoading(true);
  try {
    const response = await axios.get(`${BASE_URL1}/get-province-parish-statistics?page=${currentPage}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${TOKEN}`
      },
      params: {
        province_id: province1 || ''
      }
    });

    const resultsss = response.data?.data?.data;
    setAccounts(resultsss);
    const resultx = response.data?.data?.total;
    setTotalEntries(resultx);
    const total = response.data?.data?.last_page || 1;
    setTotalPages(total);
    
  } catch (error) {
    if (error.response && error.response.status === 401) {
      navigate('/login');
    } else {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
    }
  } finally {
    setSavingsLoading(false);
  }
};




  // const filteredAccounts = accounts.filter((item) => {
  //   const term = searchTerm.toLowerCase();
  //   return (
  //     item.details?.toLowerCase().includes(term) ||
  //     item.cheque_number?.toLowerCase().includes(term) ||
  //     item.transaction_date?.toLowerCase().includes(term)
  //   );
  // });




  function formatDates(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };

  const formattedTotalEntries = totalEntries.toLocaleString();



  const formatStat = (value) => {
    if (value == null) return "";

    if (value >= 1000 && value < 1000000) {
      const rounded = value / 1000;
      // If divisible by 1000 exactly, no decimals (30k)
      if (value % 1000 === 0) {
        return `${rounded}k`;
      }
      // Else show 2 decimals (30.01k)
      return `${rounded.toFixed(2)}k`;
    }

    if (value >= 1000000) {
      const rounded = value / 1000000;
      if (value % 1000000 === 0) {
        return `${rounded}M`;
      }
      return `${rounded.toFixed(2)}M`;
    }

    // smaller than 1000 → just locale string with commas
    return value.toLocaleString("en-US");
  };

  const isSearching = searchTerm.trim() !== "" && searchedResult.length > 0;
  const handleDateChange1 = (event) => {
    setSelectedEndDate(event.target.value);
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleBank = (selectedOption) => {
    setSelectedBank(selectedOption);
  };

  const handleCreate = () => {

  }

const fetchContinents = async () => {
  setIsLoading(true);
  try {
    const response = await axios.get(`${BASE_URL1}/continents`, 
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );

    const resultsss = response.data?.data;
    const options = resultsss.map((item) => ({
      label: item.description,
      value: item.id,
    }));
    setSelectOptions(options);
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
    }
    setSelectOptions([]);
  } finally {
    setIsLoading(false);
  }
};


  useEffect(() => {
    if (bearer) {
      fetchContinents();
    }
  }, [bearer]);



const fetchSubContinents = async () => {
  setLoad(true);
  try {
    const response = await axios.get(`${BASE_URL1}/continents/getcontinentregions?continent_id=${selectedContinent}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${TOKEN}`,
        },
      });

    const subCont = response.data?.data;
    const options1 = subCont.map((item) => ({
      label: item.description,
      value: item.id,
    }));
    setTableData3(options1);
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
    }
    setTableData3([]);
  } finally {
    setLoad(false);
  }
};

const fetchSubRegion = async () => {
  setLoad(true);
  try {
    const response = await axios.get(`${BASE_URL1}/regions/getprovincesregion?region_id=${selectedRegion}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${TOKEN}`,
        },
      });

    const subCont1 = response.data?.data;
    const options2 = subCont1.map((item) => ({
      label: item.description,
      value: item.id,
    }));
    setTableData4(options2);
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
    }
    setTableData4([]);
  } finally {
    setLoad(false);
  }
};



useEffect(() => {
  if (TOKEN && selectedContinent) {
    fetchSubContinents();
  }
}, [TOKEN, selectedContinent]);

useEffect(() => {
  if (TOKEN && selectedRegion) {
    fetchSubRegion();
  }
}, [TOKEN, selectedRegion]);

useEffect(() => {
  if (TOKEN) {
    fetchContinents();
  }
}, [TOKEN]);



  const handleContinentChange = (selectedOption) => {
    setSelectedContinent(selectedOption.value);
    // setSelectedRegion('');
    // setSelectedProvince('');
  };


  const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption.value)
  }

  const handleProvinceChange = (selectedOption) => {
    setSelectedProvince(selectedOption.value)
    setProvince1(selectedOption.value)
  }


  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  useEffect(() => {
    if (inputss) {
      const debitTotal = inputss?.reduce((total, item) => total + parseFloat(item.nDebit), 0);
      const creditTotal = inputss?.reduce((total, item) => total + parseFloat(item.nCredit), 0);
      const openingBalance = inputss?.reduce((total, item) => total + parseFloat(item.opening_balance), 0);
      const closingBalance = inputss?.reduce((total, item) => total + parseFloat(item.closing_balance), 0);
      console.log("totalclosing", openingBalance);

      // Format the numbers with commas and two decimal places
      const formattedDebitTotal = debitTotal?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      const formattedCreditTotal = creditTotal?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      const formattedOpeningBalance = openingBalance?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      const formattedClosingBalance = closingBalance?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      setTotalDebit(formattedDebitTotal);
      setTotalCredit(formattedCreditTotal);
      setTotalOpening(formattedOpeningBalance);
      setTotalClosing(formattedClosingBalance);

    }
  }, [inputss]);

  // useEffect(() => {
  //   if (inputss) {
  //     const creditTotal = inputss
  //       .filter((item) => !isNaN(item.nCredit) && item.nCredit !== "")
  //       .reduce((total, item) => total + parseFloat(item.nCredit), 0);

  //     const debitTotal = inputss
  //       .filter((item) => !isNaN(item.nDebit) && item.nDebit !== "")
  //       .reduce((total, item) => total + parseFloat(item.nDebit), 0);


  //       const openingTotal = inputss
  //       .filter((item) => !isNaN(item.opening_balance) && item.opening_balance !== "")
  //       .reduce((total, item) => total + parseFloat(item.opening_balance), 0);

  //   const closingTotal = inputss
  //       .filter((item) => !isNaN(item.closing_balance) && item.closing_balance !== "")
  //       .reduce((total, item) => total + parseFloat(item.closing_balance), 0);
  //     // Format the numbers with commas and two decimal places
  //     const formattedDebitTotal = debitTotal.toLocaleString('en-US', {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2,
  //     });

  //     const formattedOpeningTotal = openingTotal.toLocaleString('en-US', {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2,
  //   });
  //   const formattedClosingTotal = closingTotal.toLocaleString('en-US', {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2,
  //   });

  //     const formattedCreditTotal = creditTotal.toLocaleString('en-US', {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2,
  //     });

  //     setTotalDebit(formattedDebitTotal);
  //     setTotalCredit(formattedCreditTotal);
  //     setTotalOpening(formattedOpeningTotal);
  //     setTotalClosing(formattedClosingTotal);
  //   }
  // }, [inputss]);

    //   const creditTotal = inputss
    //     .filter((item) => !isNaN(item.nCredit) && item.nCredit !== "")
    //     .reduce((total, item) => total + parseFloat(item.nCredit), 0);

    //   const debitTotal = inputss
    //     .filter((item) => !isNaN(item.nDebit) && item.nDebit !== "")
    //     .reduce((total, item) => total + parseFloat(item.nDebit), 0);


    //     const openingTotal = inputss
    //     .filter((item) => !isNaN(item.opening_balance) && item.opening_balance !== "")
    //     .reduce((total, item) => total + parseFloat(item.opening_balance), 0);

    // const closingTotal = inputss
    //     .filter((item) => !isNaN(item.closing_balance) && item.closing_balance !== "")
    //     .reduce((total, item) => total + parseFloat(item.closing_balance), 0);
    //   // Format the numbers with commas and two decimal places
    //   const formattedDebitTotal = debitTotal.toLocaleString('en-US', {
    //     minimumFractionDigits: 2,
    //     maximumFractionDigits: 2,
    //   });

    //   const formattedOpeningTotal = openingTotal.toLocaleString('en-US', {
    //     minimumFractionDigits: 2,
    //     maximumFractionDigits: 2,
    // });
    // const formattedClosingTotal = closingTotal.toLocaleString('en-US', {
    //     minimumFractionDigits: 2,
    //     maximumFractionDigits: 2,
    // });

    //   const formattedCreditTotal = creditTotal.toLocaleString('en-US', {
    //     minimumFractionDigits: 2,
    //     maximumFractionDigits: 2,
    //   });

    //   setTotalDebit(formattedDebitTotal);
    //   setTotalCredit(formattedCreditTotal);
    //   setTotalOpening(formattedOpeningTotal);
    //   setTotalClosing(formattedClosingTotal);

      const tableRef = useRef(null);

  const handlePrint = () => {
    window.print();
  };
const jsPDF = require("jspdf").jsPDF;
require("jspdf-autotable");
      // Function to handle Excel export
    const exportToExcel = async () => {
      // Fetch all data (not just current page)
      const dataToExport = inputss;
  
      if (!dataToExport || dataToExport.length === 0) {
        console.log("No data available to export");
        return;
      }
      console.log("Fetched Data:", dataToExport);
  
      // Format data for Excel (match your table headers)
      const formattedData = dataToExport.map((item, index) => ({
        'S/N': index + 1,
        'Account Code': item.code,
        'Account Name': item.name,
        'Type': item.type,
        'Begining Balance': item.opening_balance,
        'Debit': item.nDebit,
        'Credit': item.nCredit,
        'Ending Balance': item.closing_balance,
         // Your formatDate function
      }));
  
      // Create a worksheet
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      // Create a workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'TrialBalanceReport');
  
      // Generate Excel file buffer
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      // Create a Blob for download
      const file = new Blob([excelBuffer], { type: 'application/octet-stream' });
      // Trigger download
      saveAs(file, 'TrialBalanceReport.xlsx');
    };
  
const exportToPDF = () => {
  const dataToExport = inputss;
  const dataToExport2 = accounts;

  if (!dataToExport || dataToExport.length === 0) {
    console.log("No data available to export");
    return;
  }

  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();

  //   // --- Header Section ---
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("The Redeemed Christian Church Of God", pageWidth / 2, 15, {
    align: "center",
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(13);
  doc.text(dataToExport2?.name || "", pageWidth / 2, 23, {
    align: "center",
  });

  doc.setFontSize(11);
  const startDate = dataToExport2?.start_date
    ? new Date(dataToExport2.start_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "--";

  const endDate = dataToExport2?.end_date
    ? new Date(dataToExport2.end_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "--";

  doc.text(
    `Trial Balance Report between the period of ${startDate} to ${endDate}`,
    pageWidth / 2,
    30,
    { align: "center" }
  );
  // // ✅ Title
  // doc.setFontSize(16);
  // doc.text("Trial Balance Report", pageWidth / 2, 15, { align: "center" });

  // ✅ Opening Balance Header Section
  const openingBalance = parseFloat(accounts?.[0]?.opening_balance || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  doc.setFontSize(12);
  doc.setTextColor(59, 130, 246); // blue
  doc.text(`Opening Balance: ${openingBalance}`, 14, 25);

  // ✅ Table Headers
  const columns = [
    { header: "S/N", dataKey: "sn" },
    { header: "Account Code", dataKey: "code" },
    { header: "Account Name", dataKey: "name" },
    { header: "Type", dataKey: "type" },
    { header: "Beginning Balance", dataKey: "opening_balance" },
    { header: "Debit", dataKey: "nDebit" },
    { header: "Credit", dataKey: "nCredit" },
    { header: "Ending Balance", dataKey: "closing_balance" },
  ];

  // ✅ Table Rows
  const rows = dataToExport.map((item, index) => ({
    sn: index + 1,
    code: item.code || "",
    name: item.name || "",
    type: item.type || "",
    opening_balance: (parseFloat(item.opening_balance) || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
    nDebit: (parseFloat(item.nDebit) || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
    nCredit: (parseFloat(item.nCredit) || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
    closing_balance: (parseFloat(item.closing_balance) || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
  }));

  // ✅ Totals Row (footer)
  const totalRow = {
    sn: "",
    code: "",
    name: "TOTALS",
    type: "",
    opening_balance: totalOpening,
    nDebit: totalDebit,
    nCredit: totalCredit,
    closing_balance: totalClosing,
  };

  rows.push(totalRow);

  // ✅ Generate the Table
  doc.autoTable({
    columns,
    body: rows,
    startY: 32,
    styles: { fontSize: 8, cellPadding: 3 },
    headStyles: { fillColor: [0, 51, 102], textColor: 255, fontSize: 9 },
    alternateRowStyles: { fillColor: [245, 245, 245] },
    columnStyles: {
      name: { cellWidth: 40 },
      type: { cellWidth: 25 },
      opening_balance: { halign: "right" },
      nDebit: { halign: "right" },
      nCredit: { halign: "right" },
      closing_balance: { halign: "right" },
    },
    didDrawPage: (data) => {
      // ✅ Footer: date + page number
      const pageCount = doc.internal.getNumberOfPages();
      const pageSize = doc.internal.pageSize;
      const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();

      doc.setFontSize(10);
      doc.setTextColor(100);
      doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, pageHeight - 10);
      doc.text(`Page ${data.pageNumber} of ${pageCount}`, pageWidth - 30, pageHeight - 10);
    },
  });

  doc.save("TrialBalanceReport.pdf");
};


// const exportToPDF = () => {
//   const dataToExport = inputss;
//   const dataToExport2 = accounts;

//   if (!dataToExport || dataToExport.length === 0) {
//     console.log("No data available to export");
//     return;
//   }

//   const doc = new jsPDF("p", "mm", "a4");
//   const pageWidth = doc.internal.pageSize.getWidth();

//   // --- Header Section ---
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(16);
//   doc.text("The Redeemed Christian Church Of God", pageWidth / 2, 15, {
//     align: "center",
//   });

//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(13);
//   doc.text(dataToExport2?.name || "", pageWidth / 2, 23, {
//     align: "center",
//   });

//   doc.setFontSize(11);
//   const startDate = dataToExport2?.start_date
//     ? new Date(dataToExport2.start_date).toLocaleDateString("en-US", {
//         year: "numeric",
//         month: "long",
//         day: "numeric",
//       })
//     : "--";

//   const endDate = dataToExport2?.end_date
//     ? new Date(dataToExport2.end_date).toLocaleDateString("en-US", {
//         year: "numeric",
//         month: "long",
//         day: "numeric",
//       })
//     : "--";

//   doc.text(
//     `Trial Balance Report between the period of ${startDate} to ${endDate}`,
//     pageWidth / 2,
//     30,
//     { align: "center" }
//   );

//   // --- Table Section ---
//   const columns = [
//     { header: "S/N", dataKey: "sn" },
//     { header: "Account Code", dataKey: "code" },
//     { header: "Account Name", dataKey: "name" },
//     { header: "Type", dataKey: "type" },
//     { header: "Beginning Balance", dataKey: "opening_balance" },
//     { header: "Debit", dataKey: "nDebit" },
//     { header: "Credit", dataKey: "nCredit" },
//     { header: "Ending Balance", dataKey: "closing_balance" },
//   ];

//   const rows = dataToExport.map((item, index) => ({
//     sn: index + 1,
//     code: item.code,
//     name: item.name,
//     type: item.type,
//     opening_balance: item.opening_balance,
//     nDebit: item.nDebit,
//     nCredit: item.nCredit,
//     closing_balance: item.closing_balance,
//   }));

//   doc.autoTable({
//     columns,
//     body: rows,
//     startY: 38, // start table below header
//     styles: {
//       fontSize: 8,
//       cellPadding: 3,
//     },
//     headStyles: {
//       fillColor: [0, 51, 102], // deep blue
//       textColor: 255,
//       fontSize: 9,
//       halign: "center",
//     },
//     alternateRowStyles: {
//       fillColor: [245, 245, 245],
//     },
//   });

//   // --- Optional Footer ---
//   const dateGenerated = new Date().toLocaleDateString();
//   doc.setFontSize(7);
//   doc.text(`Generated on: ${dateGenerated}`, 14, doc.internal.pageSize.getHeight() - 10);

//   doc.save("TrialBalanceReport.pdf");
// };



  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.backTxt}>
          <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => navigate(-1)} />
          <div className={classes.bckText}>
            <h3 className={classes.topText}>Compliance Report</h3>
          </div>
        </div>

        <div style={{ marginTop: 12 }} />
        <div className={classes.topNavBars}>
          <div className={classes.filterRow}>
            {/* Left side: Inputs */}
            <div className={classes.filterInputs}>
            
              <div className={classes.inlineField}>

                <label className={classes.inlineLabel}>Continent:</label>
                                <Select
                                  onChange={handleContinentChange}
                                  options={selectOptions}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    container: (provided) => ({
                                      ...provided,
                                      width: 200, // ✅ fixed width
                                      fontSize: 14, // applies to the wrapper
                                    }),
                                    control: (provided) => ({
                                      ...provided,
                                      minHeight: "36px",
                                      fontSize: 14, // ✅ font size inside control
                                    }),
                                    singleValue: (provided) => ({
                                      ...provided,
                                      fontSize: 14, // ✅ selected value text
                                    }),
                                    option: (provided, state) => ({
                                      ...provided,
                                      fontSize: 14, // ✅ dropdown option text
                                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                      color: "#111827",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      maxHeight: "300px",
                                      maxWidth: "200px",
                                      overflowY: "auto",
                                      fontSize: 14, // ✅ font size in menu
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  className={classes.inlineSelect}
                                />

              </div>
                {/* {admin === "Regional Accountant" && ( */}
                              {/* <div className={classes.inlineField}>
                                <label className={classes.inlineLabel}>Provinces:</label>
                                <Select
                                  onChange={handleProvinceChange}
                                  options={tableData45}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    container: (provided) => ({
                                      ...provided,
                                      width: 200, 
                                      fontSize: 14, 
                                    }),
                                    control: (provided) => ({
                                      ...provided,
                                      minHeight: "36px",
                                      fontSize: 14,
                                    }),
                                    singleValue: (provided) => ({
                                      ...provided,
                                      fontSize: 14, 
                                    }),
                                    option: (provided, state) => ({
                                      ...provided,
                                      fontSize: 14, 
                                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                      color: "#111827",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      maxHeight: "300px",
                                      maxWidth: "200px",
                                      overflowY: "auto",
                                      fontSize: 14, 
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  className={classes.inlineSelect}
                                />
                
                              </div> */}
                              {/* )} */}


                              {/* {admin === "Continental Accountant" && ( */}
                                <div style={{display: "flex", gap: 20}}>
                                <div className={classes.inlineField}>
                                <label className={classes.inlineLabel}>Region:</label>
                                <Select
                                  onChange={handleRegionChange}
                                  options={tableData3}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    container: (provided) => ({
                                      ...provided,
                                      width: 200,
                                      fontSize: 14, 
                                    }),
                                    control: (provided) => ({
                                      ...provided,
                                      minHeight: "36px",
                                      fontSize: 14, 
                                    }),
                                    singleValue: (provided) => ({
                                      ...provided,
                                      fontSize: 14, 
                                    }),
                                    option: (provided, state) => ({
                                      ...provided,
                                      fontSize: 14, 
                                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                      color: "#111827",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      maxHeight: "300px",
                                      maxWidth: "200px",
                                      overflowY: "auto",
                                      fontSize: 14, 
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  className={classes.inlineSelect}
                                />
                
                              </div>

                              <div className={classes.inlineField}>
                                <label className={classes.inlineLabel}>Province:</label>
                                <Select
                                  onChange={handleProvinceChange}
                                  options={tableData4}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    container: (provided) => ({
                                      ...provided,
                                      width: 200, // ✅ fixed width
                                      fontSize: 14, // applies to the wrapper
                                    }),
                                    control: (provided) => ({
                                      ...provided,
                                      minHeight: "36px",
                                      fontSize: 14, // ✅ font size inside control
                                    }),
                                    singleValue: (provided) => ({
                                      ...provided,
                                      fontSize: 14, // ✅ selected value text
                                    }),
                                    option: (provided, state) => ({
                                      ...provided,
                                      fontSize: 14, // ✅ dropdown option text
                                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                                      color: "#111827",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      maxHeight: "300px",
                                      maxWidth: "200px",
                                      overflowY: "auto",
                                      fontSize: 14, // ✅ font size in menu
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  className={classes.inlineSelect}
                                />
                
                              </div>
                              </div>
                              {/* )} */}
                {/* <label className={classes.inlineLabel}>Account:</label> */}
                {/* <Select
                  onChange={handleBank}
                  options={allAccounts}
                  menuPortalTarget={document.body}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: 200, // ✅ fixed width
                      fontSize: 14, // applies to the wrapper
                    }),
                    control: (provided) => ({
                      ...provided,
                      minHeight: "36px",
                      fontSize: 14, // ✅ font size inside control
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      fontSize: 14, // ✅ selected value text
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: 14, // ✅ dropdown option text
                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                      color: "#111827",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      maxWidth: "200px",
                      overflowY: "auto",
                      fontSize: 14, // ✅ font size in menu
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  className={classes.inlineSelect}
                /> */}

              

              {/* Start Date */}
              {/* <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Start Date:</label>
                <input
                  className="form-control"
                  type="date"
                  onChange={handleDateChange}
                  value={selectedDate}
                  style={{ fontSize: 14 }}
                  min={minDate}
                  max={maxDate}
                  required
                />
              </div> */}

              {/* End Date */}
              {/* <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>End Date:</label>
                <input
                  className="form-control"
                  type="date"
                  onChange={handleDateChange1}
                  value={selectedEndDate}
                  style={{ fontSize: 14 }}
                
                  required
                />
              </div> */}
              <button className={classes.loanBtn} onClick={fetchAccounts}> <img src={run} alt="run-report" /> Run Report </button>
            </div>

            {/* Right side: 3 icons */}

          </div>


        </div>
        <div className={classes.marginKilode} />

<div className={classes.tableContainer}>
        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <thead>
              <tr>
                <th>#</th>
                <th>Parish Name</th>
                <th>Registered</th>
                <th>Approved</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              {savingsLoading ? (
                Array(5).fill().map((_, idx) => (
                  <tr key={idx}>
                    {Array(5).fill().map((_, i) => (
                      <td key={i}>
                        <Skeleton height={20} style={{ marginBottom: 10 }} />
                      </td>
                    ))}
                  </tr>
                ))
              ) : accounts.length === 0 ? (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center", padding: "40px" }}>
                    No data found.
                  </td>
                </tr>
              ) : (
                accounts.map((item, index) => (
                  <tr key={index}>
                    <td>{(currentPage - 1) * entriesPerPage + index + 1}</td>
                    <td>{item.parish}</td>
                    <td>{item.registered}</td>
                    <td>{item.approved}</td>
                    <td>{item.value}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          
          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button onClick={handlePrevPage} disabled={currentPage === 1}>
                Previous
              </button>
              {[...Array(totalPages)].map((_, page) => {
                if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                  return (
                    <button
                      key={page + 1}
                      style={{
                        color: page + 1 === currentPage ? '#ffffff' : '#000',
                        backgroundColor: page + 1 === currentPage ? '#174384' : 'gainsboro',
                      }}
                      onClick={() => setCurrentPage(page + 1)}
                    >
                      {page + 1}
                    </button>
                  );
                }
                return null;
              })}
              <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                Next
              </button>
              <span className={classes.pageText}>
                Displaying {((currentPage - 1) * entriesPerPage) + 1} - {Math.min(currentPage * entriesPerPage, totalEntries)} of {totalEntries}
              </span>
            </div>
          </div>
        </div>
      </div>

              </div>
       




          {savingsLoading && (
            <div className={classes.overlay}>
              <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
            </div>
          )}

        </div>
        )
}
        export default ComplianceReport;
